// eslint-disable-next-line import/prefer-default-export
export const LVIV_COORDINATES = { lat: 49.842957, lng: 24.031111 };
